<script setup>
import axios from '@/helpers/axios'
import DashboardAlerts from '@/views/dashboard/DashboardAlerts.vue'
import DashboardDevices from '@/views/dashboard/DashboardDevices.vue'
import DashboardMap from '@/views/dashboard/DashboardMap.vue'
import DashboardFavorites from '@/views/dashboard/DashboardFavorites.vue'

definePage({
  meta: {
    layout: 'default',
    role: 'user'
  },
})

const user = ref(useCookie('userData').value)


const data = ref(null)

axios.get('/dashboard').then(r => {
  data.value = r.data
}).catch(e => {
  console.error(e)
})

</script>

<template>
  <div>
    <div>
      <h3 class="text-h3 text-no-wrap font-weight-semibold">
        {{ $t('dashboard.hello', { name: user.name }) }} 👋
      </h3>
    </div>
    <VRow v-if="data" class="match-height mt-2">
      <VCol
        cols="12"
        md="3"
      >
        <DashboardDevices :data="data" />
      </VCol>
      <VCol
        cols="12"
        md="3"
      >
        <DashboardFavorites :data="data" />
      </VCol>
      <VCol
        cols="12"
        md="3"
      >
        <DashboardAlerts :data="data" />
      </VCol>
    </VRow>
    <VRow v-if="data" class="match-height mt-2">
      <VCol
        cols="12"
        md="12"
      >
        <DashboardMap :data="data" />
      </VCol>
    </VRow>
  </div>
</template>
